"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("./Support/BaseUri");
var Request = require("./Support/Request");
function getOrderSearchPage(pageSize, page, opts) {
    if (page === void 0) { page = 0; }
    if (opts === void 0) { opts = {}; }
    var url = BaseUri.compose()
        .segment('account')
        .segment('orders')
        .query({
        '$top': pageSize,
        '$skip': pageSize * page
    }).readable();
    return Request.postJson(url, opts);
}
exports.getOrderSearchPage = getOrderSearchPage;
function getOrderById(orderId) {
    var url = BaseUri.compose()
        .segment('account')
        .segment('orders')
        .segment(orderId.toString())
        .toString();
    return Request.getJson(url);
}
exports.getOrderById = getOrderById;
function getTryksInOrder(orderId) {
    var url = BaseUri.compose()
        .segment('account')
        .segment('orders')
        .segment(orderId.toString())
        .segment('tryks')
        .toString();
    return Request.getJson(url);
}
exports.getTryksInOrder = getTryksInOrder;
function getTrykById(trykId) {
    var url = BaseUri.compose()
        .segment('account')
        .segment('tryks')
        .segment(trykId.toString())
        .toString();
    return Request.getJson(url);
}
exports.getTrykById = getTrykById;
function getTrykThumbnailUrl(trykId) {
    var url = BaseUri.compose()
        .segment('account')
        .segment('tryks')
        .segment(trykId.toString())
        .segment('thumbnail')
        .toString();
    return url;
}
exports.getTrykThumbnailUrl = getTrykThumbnailUrl;
function getDesignsInTryk(trykId) {
    var url = BaseUri.compose()
        .segment('account')
        .segment('tryks')
        .segment(trykId.toString())
        .segment('designs')
        .toString();
    return Request.getJson(url);
}
exports.getDesignsInTryk = getDesignsInTryk;
function getDestinationsInTryk(trykId) {
    var url = BaseUri.compose()
        .segment('account')
        .segment('tryks')
        .segment(trykId.toString())
        .segment('destinations')
        .toString();
    return Request.getJson(url);
}
exports.getDestinationsInTryk = getDestinationsInTryk;
